<template>
  <div class="vue-color__saturation"
    :style="{background: bgColor}"
    ref="container"
    @mousedown="handleMouseDown">
    <div class="vue-color__saturation--white"></div>
    <div class="vue-color__saturation--black"></div>
    <div class="vue-color__saturation--pointer" :style="{top: pointerTop, left: pointerLeft}">
      <div class="vue-color__saturation--circle"></div>
    </div>
  </div>
</template>

<script>
import throttle from 'lodash.throttle'

export default {
  name: 'Saturation',
  props: {
    value: Object
  },
  computed: {
    colors () {
      return this.value
    },
    bgColor () {
      return `hsl(${this.colors.hsl.h}, 100%, 50%)`
    },
    pointerTop () {
      return -(this.colors.hsv.v * 100) + 100 + '%'
    },
    pointerLeft () {
      return this.colors.hsv.s * 100 + '%'
    }
  },
  methods: {
    throttle: throttle((fn, data) => {
      fn(data)
    }, 20,
      {
        'leading': true,
        'trailing': false
      }),
    handleChange (e, skip) {
      !skip && e.preventDefault()
      var container = this.$refs.container
      var containerWidth = container.clientWidth
      var containerHeight = container.clientHeight

      var xOffset = container.getBoundingClientRect().left + window.pageXOffset
      var yOffset = container.getBoundingClientRect().top + window.pageYOffset
      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0)
      var pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0)
      var left = pageX - xOffset
      var top = pageY - yOffset

      if (left < 0) {
        left = 0
      } else if (left > containerWidth) {
        left = containerWidth
      } else if (top < 0) {
        top = 0
      } else if (top > containerHeight) {
        top = containerHeight
      }

      var saturation = left * 100 / containerWidth
      var bright = -(top * 100 / containerHeight) + 100

      this.throttle(this.onChange, {
        h: this.colors.hsl.h,
        s: saturation,
        v: bright > 0 ? bright : 0.01, // avoid TinyColor change to black when v === 0 check issue (https://github.com/bgrins/TinyColor/issues/86)
        a: this.colors.hsl.a,
        source: 'hsva'
      })
    },
    onChange (param) {
      this.$emit('change', param)
    },
    handleMouseDown (e) {
      // this.handleChange(e, true)
      window.addEventListener('mousemove', this.handleChange)
      window.addEventListener('mouseup', this.handleChange)
      window.addEventListener('mouseup', this.handleMouseUp)
    },
    handleMouseUp (e) {
      this.unbindEventListeners()
    },
    unbindEventListeners () {
      window.removeEventListener('mousemove', this.handleChange)
      window.removeEventListener('mouseup', this.handleChange)
      window.removeEventListener('mouseup', this.handleMouseUp)
    }
  }
}
</script>

<style lang="stylus">
.vue-color__saturation
.vue-color__saturation--white
.vue-color__saturation--black
  cursor pointer
  position absolute
  top 0
  left 0
  right 0
  bottom 0

.vue-color__saturation--white
  background linear-gradient(to right, #fff, rgba(255,255,255,0))
.vue-color__saturation--black
  background linear-gradient(to top, #000, rgba(0,0,0,0))
.vue-color__saturation--pointer
  cursor pointer
  position absolute
.vue-color__saturation--circle
  cursor head
  width 4px
  height 4px
  box-shadow 0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3), 0 0 1px 2px rgba(0,0,0,.4)
  border-radius 50%
  transform translate(-2px, -2px)
</style>


// WEBPACK FOOTER //
// Saturation.vue?34a64e45